import { AspCancelBillRequest } from 'vopay';
import { useState } from 'react';
import { useApi } from '#shared/providers/Api';

export default function useCancelAspBill() {
  const api = useApi();
  const [cancelling, setCancelling] = useState(false);

  async function cancelAspBill(params: AspCancelBillRequest) {
    try {
      setCancelling(true);
      const res = await api.cancelAspBill(params);
      if (!res.Success) throw new Error(res.ErrorMessage);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setCancelling(false);
    }
  }

  return { cancelling, cancelAspBill };
}
